var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4FB1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4184 25.0874V17.58H6.91009C6.49158 17.5795 6.09144 17.4129 5.79551 17.117C5.49957 16.821 5.33357 16.4197 5.33301 16.0012C5.33357 15.5826 5.49957 15.1814 5.79551 14.8854C6.09144 14.5894 6.49158 14.4229 6.91009 14.4223H14.4184V6.91599C14.4184 6.49694 14.585 6.09524 14.8809 5.79864C15.1769 5.50203 15.5786 5.33483 15.9976 5.33398C16.4168 5.33483 16.8183 5.5018 17.1143 5.79864C17.4103 6.09548 17.577 6.4978 17.5768 6.91703V14.4233H25.0872C25.5057 14.4239 25.9058 14.5904 26.2018 14.8864C26.4977 15.1824 26.6658 15.5836 26.6663 16.0022C26.6658 16.4208 26.4977 16.822 26.2018 17.118C25.9058 17.414 25.5057 17.5805 25.0872 17.5811H17.5768V25.0884C17.5769 25.2958 17.5352 25.5011 17.4559 25.6927C17.3766 25.8843 17.2609 26.0586 17.1143 26.2053C16.9676 26.3519 16.7934 26.4682 16.6018 26.5475C16.4102 26.6268 16.2049 26.6675 15.9976 26.6673C15.7901 26.6675 15.5851 26.6264 15.3934 26.547C15.2018 26.4676 15.0276 26.3515 14.8809 26.2047C14.7343 26.058 14.6185 25.8839 14.5393 25.6922C14.46 25.5004 14.4181 25.2949 14.4184 25.0874Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/Icon-Plus.b8fbcb3a.svg";
export { ForwardRef as ReactComponent };